import React from "react";
import CoreFilter from "./../CoreFilter";
import PropTypes from "prop-types";
import { eventTypeList } from "./../../modules/eventTypes";

const timeList = [
  { value: "today", label: "Today" },
  { value: "tomorrow", label: "Tomorrow" },
  { value: "thisWeekend", label: "This weekend" },
  { value: "nextWeek", label: "Next week" },
  { value: "nextWeekend", label: "Next weekend" },
  // { value: "nextMonth", label: "Next month" },
];

const EventsSectionFilter = ({ selected, timeSelected,eventGobalFilter,choosenFilters }) => (


      <CoreFilter
        selected={selected}
        filterList={choosenFilters}
        isEvents={true}
        timeList={timeList}
        timeSelected={timeSelected}
        modal={true}
      />
   
 

  
);

export default EventsSectionFilter;

EventsSectionFilter.propTypes = {
  selected: PropTypes.func,
  timeSelected: PropTypes.func,
  eventGobalFilter:PropTypes.func,
};
